import React, { useState } from 'react';
import { View, Text } from 'react-native'
import moment from 'moment';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './index';
import DateInput from 'app/src/elements/DateInput';

const TitlesReceivedReport = () => {
  const [startOn, setStartOn] = useState(
    moment().subtract({ months: 1 }).format('YYYY-MM-DD')
  );

  const [endOn, setEndOn] = useState(
    moment().format('YYYY-MM-DD')
  );

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'titles-received-report',
      params: { 'start-on': startOn, 'end-on': endOn }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Titles Received - Sold Assets Only</Text>
      <Text style={styles.label}>Start On (title received date):</Text>
      <DateInput
        style={styles.select}
        onChange={e => setStartOn(e.target.value)}
        value={startOn || ''}
      />
      <Text style={styles.label}>End On (title received date):</Text>
      <DateInput
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default TitlesReceivedReport;
